import {createSlice} from "@reduxjs/toolkit";
import config from "../Config/config";

const initialState = () => {
    const savedState = JSON.parse(localStorage.getItem("buyCartState"));
    return savedState || {items: [], Amount: 0, Weight: 0};
};

const BuyCart = createSlice({
    name: "BuyCart",
    initialState: initialState(),
    reducers: {
        addBuy(state, action) {
            const {items, quantity} = action.payload;
            const available = "available";
            const stockId = Array.isArray(items.stockId)
                ? items.stockId[0]
                : items.stockId;
            const existingBook = state.items.find((item) => item.isbn === items.isbn);
            if (existingBook) {
                return;
            } else {
                let imageUrl = `${config.imageUrlBase}${items.isbn}.jpg`;
                state.items.push({...items, quantity, available, imageUrl, stockId});
                state.Amount += quantity * parseInt(items.sellingPrice, 10);
                state.Weight += quantity * parseInt(items.weight, 10);
            }
            localStorage.setItem("buyCartState", JSON.stringify(state));
        },
        buyRemove(state, action) {
            const updatedItems = state.items.filter(
                (item) => item.isbn !== action.payload.isbn
            );
            const removedItem = state.items.find(
                (item) => item.isbn === action.payload.isbn
            );
            const newAmount =
                state.Amount -
                parseInt(removedItem.sellingPrice, 10) * removedItem.quantity;
            const newWeight =
                state.Weight - parseInt(removedItem.weight, 10) * removedItem.quantity;
            state.items = updatedItems;
            state.Amount = newAmount;
            state.Weight = newWeight;
            localStorage.setItem("buyCartState", JSON.stringify(state));
        },
        buyIncreaseQuantity(state, action) {
            const book = state.items.find(
                (item) => item.isbn === action.payload.isbn
            );
            if (book) {
                book.quantity += 1;
                state.Amount += parseInt(book.sellingPrice, 10);
                state.Weight += parseInt(book.weight, 10);
                localStorage.setItem("buyCartState", JSON.stringify(state));
            }
        },
        buyDecreaseQuantity(state, action) {
            const book = state.items.find(
                (item) => item.isbn === action.payload.isbn
            );
            if (book && book.quantity > 1) {
                book.quantity -= 1;
                state.Amount -= parseInt(book.sellingPrice, 10);
                state.Weight -= parseInt(book.weight, 10);
                localStorage.setItem("buyCartState", JSON.stringify(state));
            }
        },
        buyIsAvailable(state, action) {
            const book = state.items.find((item) => item.isbn === action.payload);
            book.available = "notAvailable";
            localStorage.setItem("buyCartState", JSON.stringify(state));
        },
        clearBuyCart(state) {
            state.items = [];
            state.Amount = 0;
            state.Weight = 0;
            localStorage.setItem("buyCartState", JSON.stringify(state));
        },
    },
});

export const {
    addBuy,
    buyRemove,
    buyIncreaseQuantity,
    buyDecreaseQuantity,
    buyIsAvailable,
    clearBuyCart,
} = BuyCart.actions;
export const BuyReducer = BuyCart.reducer;
